import { useReducer } from 'react'

const initialFilterState = {
    search: '',
    sort_by: '',
    skip: 0,
    take: 20
}

const filterReducer = (state, action) => {
    switch (action.type) {
        case 'search': {
            return {
                ...state,
                search: action.value,
                skip: 0,
                take: 20
            }
        }
        case 'sort': {
            return {
                ...state,
                sort_by: action.sort_by,
                skip: 0,
                take: 20
            }
        }
        case 'skipAndTake': {
            return {
                ...state,
                take: action.skipAndTake.take,
                skip: action.skipAndTake.skip
            }
        }
        default:
            return state
    }
}

export const useSimCardsFilters = initialFilters =>
    useReducer(filterReducer, { ...initialFilterState, ...initialFilters })
